import { Link } from '@tanstack/react-router';
import { ArrowRightIcon, UserRoundXIcon } from 'lucide-react';

import { buttonVariants } from '@/components/ui/button';
import { EyebrowLabel } from '@/shared/components/EyebrowLabel';

import { useAdminWorkspaces } from '../hooks/useAdminWorkspaces';
import { WORKSPACES_COPY } from '../workspacesAdmin';

const WORDS = WORKSPACES_COPY.ownerless;

/**
 * The Admin Overview's "Needs a look" for workspaces (spec 195 US5): how many
 * have no active owner, with a way to that slice of Admin → Workspaces. Nothing
 * at all when every workspace has one — or before the list is read, or if it
 * could not be: a line that is not about a problem is one more thing to skip.
 */
export function OwnerlessWorkspaces() {
  const workspaces = useAdminWorkspaces();
  const count = workspaces.data?.without_active_owner ?? 0;
  if (count === 0) return null;

  return (
    <section
      aria-labelledby="admin-overview-needs-a-look"
      className="flex min-w-0 flex-col gap-3"
    >
      <h2 id="admin-overview-needs-a-look">
        <EyebrowLabel>{WORDS.heading}</EyebrowLabel>
      </h2>
      <div className="border-border bg-card relative flex flex-wrap items-center gap-x-3 gap-y-2 overflow-hidden rounded-md border py-2.5 ps-4 pe-3">
        <span
          aria-hidden="true"
          className="bg-state-warning absolute inset-y-0 left-0 w-[3px]"
        />
        <UserRoundXIcon
          aria-hidden="true"
          strokeWidth={1.5}
          className="text-state-warning size-4 shrink-0"
        />
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <p className="text-foreground text-sm font-medium">
            {WORDS.line(count)}
          </p>
          <p className="text-muted-foreground text-xs">{WORDS.why}</p>
        </div>
        <Link
          to="/admin/workspaces"
          search={{ show: 'without_owner' }}
          aria-label={WORDS.actionLabel}
          className={buttonVariants({ variant: 'outline', size: 'sm' })}
        >
          {WORDS.action}
          <ArrowRightIcon aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
